module.exports = require("././angular-translate.js");


//////////////////
// WEBPACK FOOTER
// angular-translate (bower component)
// module id = 60
// module chunks = 0 1